import { fetchJson, post } from "../../lib/Fetching";

function loadShoppingLists({ company_id, branch_id }) {
  return fetchJson("/products/shopping_lists", {
    company_id,
    branch_id,
  });
}

function loadShoppingList(id) {
  return fetchJson("/products/shopping_lists/" + id);
}

function loadTestingProtocols({
  company_id,
  branch_id,
  with_testing_actions,
  enabled = true,
}) {
  return fetchJson("/products/shelf_life_protocols.json", {
    company_id,
    branch_id,
    with_testing_actions,
    enabled,
  });
}

function deleteShoppingListItem({ shoppingListId, shoppingListItemId }) {
  return post(
    "/products/shopping_lists/" + shoppingListId + "/remove_item",
    { shopping_list_item_id: shoppingListItemId },
    "DELETE"
  );
}

export { loadShoppingLists, loadShoppingList, deleteShoppingListItem, loadTestingProtocols };
